import {VisualModalComponent} from "../../../../../../components/visual/modal/VisualModalComponent";
import {SiteCreditService} from "../../../../../../../services/site/credit/SiteCreditService";
import {OfferStripeComponent} from "../../stripe/OfferStripeComponent";
import {OfferPaymentActionType} from "../../../../../../../models/offer/payment/OfferPaymentActionType";
import {ISiteCreditPurchaseIncoming} from "../../../../../../../models/site/credit/ISiteCreditPurchaseIncoming";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {numberPrice} from "../../../../../../../sedestral/framework/utilities/NumberPrice";
import {LoaderLightComponent} from "../../../../../../components/global/loader/light/LoaderLightComponent";
import {
    remLoadingButton,
    setLoadingButton
} from "../../../../../../../sedestral/framework/interface/component/funcs/LoadingButton";
import {SiteAddressComponent} from "../../../site/address/SiteAddressComponent";
import {OfferInvoiceService} from "../../../../../../../services/offer/invoice/OfferInvoiceService";
import {OfferInvoiceState} from "../../../../../../../models/offer/invoice/OfferInvoiceState";
import {linkDownload} from "../../../../../../../sedestral/framework/utilities/LinkDownload";
import {Resources} from "../../../../../../../resources/Resources";
import {IOfferCreditsPresetModel} from "./types/IOfferCreditsPresetModel";
import {Services} from "../../../../../../../services/Services";
import {ErrorCode} from "../../../../../../../network/status/error/ErrorCode";
import {
    ButtonCheckBoxComponent
} from "../../../../../../components/global/buttons/check/box/ButtonCheckBoxComponent";
import {Network} from "../../../../../../../network/Network";
import * as s from "./offer-credits-modal.scss";

export class OfferCreditsModalComponent extends VisualModalComponent {

    public container: Component;
    public addressComponent: SiteAddressComponent;
    public cgvButton: ButtonCheckBoxComponent;
    public stripeComponent: OfferStripeComponent;
    public continueButton: Component;
    public payButton: Component;
    public errorContainer: Component;
    public confirmationMessage: Component;
    public confirmationLoader: Component;
    public confirmationActions: Component;
    // bornes de recharge en devise locale, chargées depuis le back à l'ouverture (le front ne convertit rien)
    public minimumAmount: number = 2000;
    public maximumAmount: number = 500000;
    public amount: number = 5000;

    public presets: IOfferCreditsPresetModel[] = [
        {amount: 5000},
        {amount: 10000},
        {amount: 20000},
        {amount: 50000},
        {amount: 100000}
    ];

    constructor(initialAmount?: number) {
        super();
        if (initialAmount && initialAmount > 0) {
            this.amount = initialAmount;
        }
        this.modalStyle = "width:700px;";
        this.name = Resources.t("words.creditRechargeTitle");
        this.autoResize = true;

        //language=HTML
        this.modalTemplate = `
            <div class="${s.componentOfferCreditsModal}">
                ${this.draw(new LoaderLightComponent())}
            </div>
        `;
    }

    commit() {
        super.commit();
        this.container = this.modalContainer.el(s.componentOfferCreditsModal);
        this.load();
    }

    async load() {
        // le back fournit les bornes déjà converties dans la devise du site (min/max local) : le front ne fait que valider/afficher
        const balance = await SiteCreditService.getBalance(this);
        if (balance) {
            this.minimumAmount = balance.minimumAmountLocal;
            this.maximumAmount = balance.maximumAmountLocal;
        }
        this.renderAmountStep();
    }

    renderAmountStep() {
        this.container.clearAll();
        this.addressComponent = new SiteAddressComponent();
        this.cgvButton = new ButtonCheckBoxComponent(false);
        this.renderAmountSection();
        this.renderAddressSection();
        this.renderCgvSection();
        this.renderError();
        this.renderContinueFooter();
        this.initPresetEvents();
        this.initContinueEvent();
    }

    renderAmountSection() {
        //language=HTML
        this.container.append(`
            <div class="${s.section}">
                <div class="${s.sectionTitle}">${Resources.t("words.creditAmount")}</div>
                <div class="${s.amountSelector}">
                    <div class="${s.amountPresets}"></div>
                    <div class="${s.customAmountContainer}">
                        ${Resources.currency.symbolBefore ? `<span class="${s.customAmountCurrency}">${Resources.currency.symbol}</span>` : ``}
                        <input type="number" class="${s.customAmountInput}"
                               placeholder="${Resources.t("words.creditCustomAmount")}"
                               min="${Math.ceil(this.minimumAmount / 100)}" max="${Math.floor(this.maximumAmount / 100)}"/>
                        ${Resources.currency.symbolBefore ? `` : `<span class="${s.customAmountCurrency}">${Resources.currency.symbol}</span>`}
                    </div>
                </div>
            </div>
        `);

        const presetsContainer = this.container.el(s.amountPresets);
        const isPreset = this.presets.some(preset => preset.amount === this.amount);
        for (const preset of this.presets) {
            const isActive = preset.amount === this.amount;
            //language=HTML
            presetsContainer.append(`
                <div class="${s.preset} ${isActive ? s.active : ``}" data-amount="${preset.amount}">${numberPrice(preset.amount, Resources.currency)}</div>
            `);
        }

        if (!isPreset && this.amount > 0) {
            const customInput = this.container.el(s.customAmountInput);
            customInput.setValue(String(Math.ceil(this.amount / 100)));
        }
    }

    renderAddressSection() {
        //language=HTML
        this.container.append(`
            <div class="${s.section}">
                <div class="${s.sectionTitle}">${Resources.t("words.creditBillingAddress")}</div>
                <div class="${s.addressContainer}">
                    ${this.container.draw(this.addressComponent)}
                </div>
            </div>
        `);
    }

    renderCgvSection() {
        //language=HTML
        this.container.append(`
            <div class="${s.cgvSection}">
                <a href="${Network.router.pages.getWebsiteUrl('cgv')}" target="_blank">
                    ${Resources.t("words.offerCgv")}
                </a>
                <span>${this.container.draw(this.cgvButton)}</span>
            </div>
        `);
    }

    renderError() {
        //language=HTML
        this.container.append(`
            <div class="${s.errorZone}"></div>
        `);
        this.errorContainer = this.container.el(s.errorZone);
    }

    renderContinueFooter() {
        //language=HTML
        this.container.append(`
            <div class="${s.footer}">
                <div class="${s.continueButton}">
                    ${Resources.t("words.creditGoToPayment")}
                </div>
            </div>
        `);
        this.continueButton = this.container.el(s.continueButton);
    }

    initPresetEvents() {
        const presetElements = this.container.els(s.preset);
        const customInput = this.container.el(s.customAmountInput);

        for (const preset of presetElements) {
            preset.onClick(() => {
                for (const other of presetElements) {
                    other.removeClass(s.active);
                }
                preset.addClass(s.active);
                this.amount = parseInt(preset.getAttribute("data-amount"));
                customInput.setValue("");
            });
        }

        customInput.onKeyUp(() => {
            const customValue = parseInt(customInput.getValue());
            if (customValue > 0) {
                for (const preset of presetElements) {
                    preset.removeClass(s.active);
                }
                this.amount = customValue * 100;
            } else {
                presetElements[0].addClass(s.active);
                this.amount = 5000;
            }
        });
    }

    initContinueEvent() {
        this.continueButton.onClick(async () => {
            this.errorContainer.clearAll();

            if (!this.cgvButton.checked) {
                Network.router.static.components.notifications.notify(Resources.t("words.offerAcceptCgv"), undefined, 3000);
                return;
            }

            if (this.amount < this.minimumAmount) {
                this.appendError(Resources.r("words.creditMinimumAmount", {amount: numberPrice(this.minimumAmount, Resources.currency, false)}));
                return;
            }

            if (this.amount > this.maximumAmount) {
                this.appendError(Resources.r("words.creditMaximumAmount", {amount: numberPrice(this.maximumAmount, Resources.currency, false)}));
                return;
            }

            if (!this.addressComponent.check()) {
                this.appendError(Resources.t("words.errorFillEmptyFieldsError"));
                return;
            }

            setLoadingButton(this.continueButton, undefined, "white");

            Services.handleErrors(this, [
                {errorCode: ErrorCode.CREDIT_MINIMUM_AMOUNT, message: Resources.r("words.creditMinimumAmount", {amount: numberPrice(this.minimumAmount, Resources.currency, false)})},
                {errorCode: ErrorCode.CREDIT_MAXIMUM_AMOUNT, message: Resources.r("words.creditMaximumAmount", {amount: numberPrice(this.maximumAmount, Resources.currency, false)})}
            ]);

            const address = this.addressComponent.getAddress();
            const purchase = await SiteCreditService.purchase({amount: this.amount, address: address}, this);

            if (!purchase) {
                remLoadingButton(this.continueButton);
                this.appendError(Resources.t("words.creditPaymentError"));
                return;
            }

            this.renderPaymentStep(purchase);
        });
    }

    renderPaymentStep(purchase: ISiteCreditPurchaseIncoming) {
        this.container.clearAll();
        this.renderBalanceRecap(purchase);
        this.renderPriceRecap(purchase);
        if (!purchase.alreadyPaid) {
            this.renderStripeSection(purchase);
        }
        this.renderError();
        this.renderPayFooter(purchase);
        this.initPayEvents(purchase);
    }

    renderBalanceRecap(purchase: ISiteCreditPurchaseIncoming) {
        //language=HTML
        this.container.append(`
            <div class="${s.recap}">
                <div class="${s.recapTitle}">${Resources.t("words.creditBalance")}</div>
                <div class="${s.recapRow}">
                    <span>${Resources.t("words.creditCurrentBalance")}</span>
                    <span>${numberPrice(purchase.currentBalance, Resources.currency, false)}</span>
                </div>
                <div class="${s.recapRow}">
                    <span>${Resources.t("words.creditFutureBalance")}</span>
                    <span>${numberPrice(purchase.futureBalance, Resources.currency, false)}</span>
                </div>
            </div>
        `);
    }

    renderPriceRecap(purchase: ISiteCreditPurchaseIncoming) {
        const hasBalanceApplied = purchase.amountPaidByBalance > 0;

        //language=HTML
        const recap = this.container.append(`
            <div class="${s.recap}">
                <div class="${s.recapTitle}">${Resources.t("words.creditRecap")}</div>
            </div>
        `);

        //language=HTML
        recap.append(`
            <div class="${s.recapRow}">
                <span>${Resources.t("words.creditAmountExcludingTax")}</span>
                <span>${numberPrice(purchase.amountExcludingTax, Resources.currency, false)}</span>
            </div>
        `);

        //language=HTML
        recap.append(`
            <div class="${s.recapRow}">
                <span>${Resources.t("words.creditTaxAmount")}</span>
                <span>${numberPrice(purchase.taxAmount, Resources.currency, false)}</span>
            </div>
        `);

        //language=HTML
        recap.append(`
            <div class="${s.recapRow}">
                <span>${Resources.t("words.creditAmountIncludingTax")}</span>
                <span>${numberPrice(purchase.amountIncludingTax, Resources.currency, true)}</span>
            </div>
        `);

        if (hasBalanceApplied) {
            //language=HTML
            recap.append(`
                <div class="${s.recapRow}">
                    <span>${Resources.t("words.creditBalanceApplied")}</span>
                    <span>-${numberPrice(purchase.amountPaidByBalance, Resources.currency, true)}</span>
                </div>
            `);
        }

        //language=HTML
        recap.append(`
            <div class="${s.recapRow} ${s.recapTotal}">
                <span>${Resources.t("words.creditAmountDue")}</span>
                <span>${numberPrice(purchase.amountDue, Resources.currency, true)}</span>
            </div>
        `);

        if (purchase.invoicePdfUrl) {
            //language=HTML
            recap.append(`
                <div class="${s.recapInvoice}">
                    <div class="${s.invoiceLink}">${Resources.t("words.creditDownloadInvoice")}</div>
                </div>
            `);
            recap.el(s.invoiceLink).onClick(() => {
                linkDownload(purchase.invoicePdfUrl, `facture-${purchase.invoiceId}.pdf`);
            });
        }
    }

    renderStripeSection(purchase: ISiteCreditPurchaseIncoming) {
        //language=HTML
        this.container.append(`
            <div class="${s.section}">
                <div class="${s.sectionTitle}">${Resources.t("words.creditPayment")}</div>
                <div class="${s.stripeContainer}"></div>
            </div>
        `);

        const stripeContainer = this.container.el(s.stripeContainer);
        this.stripeComponent = new OfferStripeComponent(purchase.secrets, OfferPaymentActionType.PAYMENT);

        this.stripeComponent.onPaid = () => {
            remLoadingButton(this.payButton);
            this.renderConfirmationStep(purchase.invoiceId);
        };

        this.stripeComponent.onError = (error?: string) => {
            remLoadingButton(this.payButton);
            if (error) {
                this.errorContainer.clearAll();
                this.appendError(error);
            }
        };

        stripeContainer.render(this.stripeComponent);
    }

    renderPayFooter(purchase: ISiteCreditPurchaseIncoming) {
        const buttonLabel = purchase.alreadyPaid
            ? Resources.t("words.creditConfirm")
            : Resources.r("words.creditPay", {amount: numberPrice(purchase.amountDue, Resources.currency, true)});

        //language=HTML
        this.container.append(`
            <div class="${s.footer}">
                <div class="${s.payButton}">
                    ${buttonLabel}
                </div>
            </div>
        `);
        this.payButton = this.container.el(s.payButton);
    }

    initPayEvents(purchase: ISiteCreditPurchaseIncoming) {
        if (purchase.alreadyPaid) {
            this.payButton.onClick(() => {
                this.renderConfirmationStep(purchase.invoiceId);
            });
            return;
        }

        this.payButton.onClick(async () => {
            if (this.stripeComponent) {
                setLoadingButton(this.payButton, undefined, "white");
                await this.stripeComponent.payment();
            }
        });
    }

    renderConfirmationStep(invoiceId: string) {
        this.container.clearAll();
        this.renderConfirmationContent();
        this.pollInvoice(invoiceId);
    }

    renderConfirmationContent() {
        //language=HTML
        this.container.append(`
            <div class="${s.confirmationStep}">
                <div class="${s.confirmationTitle}">${Resources.t("words.creditPaymentDone")}</div>
                <div class="${s.confirmationMessage}">${Resources.t("words.creditVerificationInProgress")}</div>
                <div class="${s.confirmationLoader}">
                    ${this.container.draw(new LoaderLightComponent())}
                </div>
                <div class="${s.confirmationActions}"></div>
            </div>
        `);

        this.confirmationMessage = this.container.el(s.confirmationMessage);
        this.confirmationLoader = this.container.el(s.confirmationLoader);
        this.confirmationActions = this.container.el(s.confirmationActions);
    }

    pollInvoice(invoiceId: string) {
        const pollingInterval = this.interval(async () => {
            const invoices = await OfferInvoiceService.all();
            if (!invoices) return;

            const invoice = invoices.find(
                inv => inv.remoteId === invoiceId && inv.state === OfferInvoiceState.PAYMENT_SUCCEEDED
            );
            if (!invoice) return;

            clearInterval(pollingInterval);
            this.confirmationLoader.displayHide();
            this.confirmationMessage.setText(Resources.t("words.creditAddedSuccess"));

            this.renderConfirmationActions(invoice);
            this.onCreditsPurchased();
        }, 5000);
    }

    renderConfirmationActions(invoice: { id: string, number?: string }) {
        //language=HTML
        this.confirmationActions.append(`
            <div class="${s.downloadButton}">${Resources.t("words.creditDownloadInvoice")}</div>
        `);
        //language=HTML
        this.confirmationActions.append(`
            <div class="${s.closeButton}">${Resources.t("words.creditClose")}</div>
        `);

        this.confirmationActions.el(s.downloadButton).onClick(async () => {
            const url = await OfferInvoiceService.download(invoice.id);
            if (url) {
                linkDownload(url, `facture-${invoice.number || invoice.id}.pdf`);
            }
        });

        this.confirmationActions.el(s.closeButton).onClick(() => {
            this.onCreditsPurchased();
            this.close();
        });
    }

    appendError(message: string) {
        //language=HTML
        this.errorContainer.append(`
            <div class="${s.error}">${message}</div>
        `);
    }

    onCreditsPurchased() {
    }
}
